__turbopack_context__.v({
  "imgcontainerIcon": "AircraftOverview-module-scss-module__dleMFq__imgcontainerIcon",
  "presentblock": "AircraftOverview-module-scss-module__dleMFq__presentblock",
  "presentblock1440px": "AircraftOverview-module-scss-module__dleMFq__presentblock1440px",
  "reviewOfAircraftRequirement": "AircraftOverview-module-scss-module__dleMFq__reviewOfAircraftRequirement",
  "text": "AircraftOverview-module-scss-module__dleMFq__text",
  "textcontainer": "AircraftOverview-module-scss-module__dleMFq__textcontainer",
  "weAlsoWork": "AircraftOverview-module-scss-module__dleMFq__weAlsoWork",
});
